import { Box, Chip } from "@mui/material";
import { colors } from "../../theme/palette";
import typography from "../../theme/typography";
import { useTranslation } from "react-i18next";

const GoStarRoles = ({
  handleChangeChildTabValue,
  roleTab,
  isLoading,
  setIsLoading,
}: {
  handleChangeChildTabValue: (newValue: number) => void;
  roleTab: number;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        gap: "8px",
      }}
    >
      <Chip
        label={t("pages.goStar.talents")}
        component="button"
        variant="outlined"
        clickable
        onClick={() => handleChangeChildTabValue(0)}
        sx={{
          border: "none",
          padding: "1px 4px",
          ...(roleTab === 0 ? { ...typography.body14Regular } : { ...typography.body14Regular }),
          color: roleTab === 0 ? colors.Green100 : colors.Dark600,
          background: roleTab === 0 ? colors.Green25 : "transparent",
        }}
      />
      <Chip
        label={t("pages.goStar.professionals")}
        component="button"
        variant="outlined"
        clickable
        onClick={() => handleChangeChildTabValue(1)}
        sx={{
          border: "none",
          padding: "1px 4px",
          ...(roleTab === 1 ? { ...typography.body14Regular } : { ...typography.body14Regular }),
          color: roleTab === 1 ? colors.Green100 : colors.Dark600,
          background: roleTab === 1 ? colors.Green25 : "transparent",
        }}
      />
      <Chip
        label={t("pages.goStar.entities")}
        component="button"
        variant="outlined"
        clickable
        onClick={() => handleChangeChildTabValue(2)}
        sx={{
          border: "none",
          padding: "1px 4px",
          ...(roleTab === 2 ? { ...typography.body14Regular } : { ...typography.body14Regular }),
          color: roleTab === 2 ? colors.Green100 : colors.Dark600,
          background: roleTab === 2 ? colors.Green25 : "transparent",
        }}
      />
    </Box>
  );
};

export default GoStarRoles;
